// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
        :host {
            height: 100%;
            font-size: 0.9em;

            ion-grid {
                display: inline !important;
            }
        }
    
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZpZXcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtRQUNRO1lBQ0ksWUFBWTtZQUNaLGdCQUFnQjs7WUFFaEI7Z0JBQ0ksMEJBQTBCO1lBQzlCO1FBQ0oiLCJmaWxlIjoidmlldy50cyIsInNvdXJjZXNDb250ZW50IjpbIlxuICAgICAgICA6aG9zdCB7XG4gICAgICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgICAgICBmb250LXNpemU6IDAuOWVtO1xuXG4gICAgICAgICAgICBpb24tZ3JpZCB7XG4gICAgICAgICAgICAgICAgZGlzcGxheTogaW5saW5lICFpbXBvcnRhbnQ7XG4gICAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAiXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/navigation/view/view.ts"],"names":[],"mappings":";QACQ;YACI,YAAY;YACZ,gBAAgB;;YAEhB;gBACI,0BAA0B;YAC9B;QACJ;;AAER,ofAAof","sourcesContent":["\n        :host {\n            height: 100%;\n            font-size: 0.9em;\n\n            ion-grid {\n                display: inline !important;\n            }\n        }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
